import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderCreateSlice = createApi({
    reducerPath: "orderCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        orderCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/order/create", method: "POST", body: data }),
        }),
    }),
});

export const { useOrderCreateMutation } = orderCreateSlice;
